// removed by extract-text-webpack-plugin
module.exports = {"Container":"boxList__Container__2Z1zv","ContentBox":"boxList__ContentBox__3Iu2-"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/BoxList/boxList.css
// module id = 1234
// module chunks = 2